import React from 'react'

import withWidth from '@material-ui/core/withWidth'

const ScreenSizeLabel = ({ width, ...props }) => (
  <span
    {...props}
    style={{ position: 'absolute', fontSize: 'smaller', color: 'white', backgroundColor: '#333' }}
  >
    Size: {width}
  </span>
)

export default withWidth()(ScreenSizeLabel)
